import createVueApp from '@/common/createApp'
import sidebar from '@/config/sidebars/mlap'

Styxie.Initializers.MlapSettingsCallRail = {
  show: async(props) => {
    const { default: CallRailSettings } = await import('@/vue_widgets/mlap/settings/call_rail/index.vue')
    createVueApp(CallRailSettings, { props, sidebar })
  }
}
